import React from "react";
import { Box, Modal } from "@mui/material";
import Button from "./Button";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/images/logo.svg";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  backgroundColor: "white",
  borderRadius: "12px",
  border: "1px solid #C9C9C9",
  boxShadow: 24,
  outline: "none",
  padding: "30px",
};

const NoLanguageModal = ({ open }) => {
  const navigate = useNavigate();

  const handleRedirect = () => {
    navigate("/admin/language");
  };

  return (
    <Modal
      open={open}
      aria-labelledby="no-language-modal-title"
      aria-describedby="no-language-modal-description"
      sx={{ backdropFilter: "blur(4px)" }}
    >
      <Box sx={style}>
        <div className="text-center">
          <div className="mb-4">
            <img
              src={logo}
              alt="Jallab logo"
              style={{ width: "100px", height: "100px", objectFit: "contain" }}
              onError={(e) => {
                e.target.src = "https://via.placeholder.com/100?text=Logo";
              }}
            />
          </div>
          <h3
            id="no-language-modal-title"
            className="fw-bold mb-3"
            style={{ color: "#333", fontSize: "24px" }}
          >
            Action Required
          </h3>
          <p
            id="no-language-modal-description"
            className="text-secondary mb-4"
            style={{ fontSize: "16px", lineHeight: "1.6" }}
          >
            It seems you haven't added any languages yet. Please add at least one language to proceed and access all application modules.
          </p>
          <div className="d-flex justify-content-center">
            <Button
              onClick={handleRedirect}
              btnName="Go to Language Module"
              newClass="submit-btn"
              style={{
                borderRadius: "0.5rem",
                padding: "12px 30px",
                backgroundColor: "#C41E3A",
                color: "white",
                fontWeight: "600",
                border: "none",
                fontSize: "16px",
                boxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.1)",
                cursor: "pointer"
              }}
            />
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default NoLanguageModal;
